import {ContractorDao} from '../../dao';
import {ErrorModel, ContractorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'GET_INVOICE_BY_ID';

export async function getContractorById(userData: Record<string, string>, id: number) {
    try {
        const contractor = await ContractorDao.getContractorById(userData.userToken, id);

        const contractorParsed = ContractorModel.parseContractor(contractor);

        return contractorParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
